import { YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { type SidebarSectionName } from './sticky-section';
import { SECTION_GAP } from './style';

type SidebarListItemFrameProps = React.ComponentProps<typeof YStack> & {
  section: SidebarSectionName;
  isSectionBoundary?: boolean;
  hasFollowingSection?: boolean;
};

export const SidebarListItemFrame = ({
  section,
  isSectionBoundary = false,
  hasFollowingSection = false,
  className,
  ...props
}: SidebarListItemFrameProps) => (
  <YStack
    data-sidebar-section-item={section}
    data-sidebar-section-boundary={isSectionBoundary ? section : undefined}
    className={cn(
      'pb-0.5 no-record',
      'pr-0',
      hasFollowingSection && SECTION_GAP,
      className
    )}
    {...props}
  />
);
